<div class="measures-header">
  <span class="measures-title">MEASURES</span>
</div>

@if (measureResults().length === 0) {
  <div class="measures-empty">No data</div>
} @else {
  <mat-accordion multi displayMode="flat" class="measures-accordion" (mouseleave)="onMouseLeave()">
    @for (result of standardMeasures(); track result.id) {
      <mat-expansion-panel
        class="measure-panel"
        [expanded]="isPinned(result.id)"
        (opened)="onPanelOpened(result.id)"
        (closed)="onPanelClosed(result.id)"
      >
        <mat-expansion-panel-header
          [collapsedHeight]="'36px'"
          [expandedHeight]="'36px'"
          (mouseenter)="onMouseEnter(result.id)"
          (mouseleave)="onMouseLeave()"
        >
          <mat-panel-title class="measure-header-content">
            <dojo-markdown-viewer class="measure-symbol" [content]="getDef(result.id).symbolLatex" />
            <span class="measure-label-group">
              <span class="measure-label">{{ getDef(result.id).label }}</span>
              <dojo-icon
                class="measure-info"
                icon="circle-info"
                [size]="11"
                [matTooltip]="getDef(result.id).description"
                matTooltipPosition="right"
              />
            </span>
            <span
              class="measure-value"
              [style.color]="measureColors[result.id]"
              [matTooltip]="result.formattedValue"
              [matTooltipDisabled]="result.formattedValue.length <= 12"
              >{{ result.formattedValue }}</span
            >
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div class="formula-section">
            <div class="formula-line">
              <dojo-markdown-viewer [content]="result.pluggedInLatex" />
            </div>
          </div>
          @if (measureInsights().get(result.id); as insights) {
            @for (insight of insights; track $index) {
              <div class="measure-insight-item"><dojo-markdown-viewer [content]="insight" /></div>
            }
          }
        </ng-template>
      </mat-expansion-panel>
    }

    <!-- Skewness -->
    @if (skewnessResult(); as skew) {
      <mat-expansion-panel
        class="measure-panel skewness-panel"
        [expanded]="isPinned('skewness')"
        (opened)="onPanelOpened('skewness')"
        (closed)="onPanelClosed('skewness')"
      >
        <mat-expansion-panel-header
          [collapsedHeight]="'36px'"
          [expandedHeight]="'36px'"
          (mouseenter)="onMouseEnter('skewness')"
          (mouseleave)="onMouseLeave()"
        >
          <mat-panel-title class="measure-header-content">
            <dojo-markdown-viewer class="measure-symbol" [content]="getDef('skewness').symbolLatex" />
            <span class="measure-label-group">
              <span class="measure-label">{{ getDef('skewness').label }}</span>
              <dojo-icon
                class="measure-info"
                icon="circle-info"
                [size]="11"
                [matTooltip]="getDef('skewness').description"
                matTooltipPosition="right"
              />
            </span>
            <span class="measure-value" [style.color]="measureColors['skewness']">{{ skew.formattedValue }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div class="formula-section">
            <div class="formula-line">
              <dojo-markdown-viewer [content]="skew.pluggedInLatex" />
            </div>
          </div>

          <div class="skewness-scale">
            <div class="scale-zone-labels">
              <span class="zone-group">Left-skewed</span>
              <span class="zone-group zone-group--center">Symmetric</span>
              <span class="zone-group">Right-skewed</span>
            </div>

            <div class="scale-bar">
              <div class="seg seg--strong" [class.seg--active]="skewnessScale().zone === 'strong-left'"></div>
              <div class="seg seg--moderate" [class.seg--active]="skewnessScale().zone === 'mod-left'"></div>
              <div class="seg seg--symmetric" [class.seg--active]="skewnessScale().zone === 'symmetric'"></div>
              <div class="seg seg--moderate" [class.seg--active]="skewnessScale().zone === 'mod-right'"></div>
              <div class="seg seg--strong" [class.seg--active]="skewnessScale().zone === 'strong-right'"></div>
              <div class="scale-needle" [style.left.%]="skewnessScale().position"></div>
            </div>

            <div class="scale-ticks">
              <span class="tick" style="left: 25%">−1</span>
              <span class="tick" style="left: 37.5%">−0.5</span>
              <span class="tick tick--zero" style="left: 50%">0</span>
              <span class="tick" style="left: 62.5%">0.5</span>
              <span class="tick" style="left: 75%">1</span>
            </div>
          </div>

          <div class="skewness-classification">
            <span>{{ skewnessClassification().text }}</span>
            <dojo-markdown-viewer class="skewness-threshold" [content]="skewnessClassification().thresholdLatex" />
          </div>

          @for (insight of skewnessInsights(); track $index) {
            <div class="skewness-insight-item"><dojo-markdown-viewer [content]="insight" /></div>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
}
